class News {
  constructor() {
    this.DOM = {
      news: document.querySelectorAll('.news__item'),
    };
    this.#init();
  }
  #init() {
    const now = new Date();
    this.DOM.news.forEach((item, i) => {
      const hasNewTag = item.querySelector('.news__new-tag') != null;
      if (hasNewTag) return;
      const dataElement = item.querySelector('.news__date');
      if (dataElement.hasAttribute('datetime')) {
        const date = new Date(dataElement.getAttribute('datetime'));
        const isNew = now.getTime() - date.getTime() <= 1000 * 60 * 60 * 24 * 7;
        if (isNew) {
          const newTag = document.createRange().createContextualFragment('<span class="news__new-tag">NEW</span>');
          item.insertBefore(newTag, dataElement.nextSibling);
        }
      }
    });
  }
}
export default News;